<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <div class="row m-0 mt-4 mb-4 formborder" *ngIf="dvDetail">
    <div class="col-md-2">
      <h6 class="fs-12">Application No</h6>
      <p class="lead fs-12">{{ dvDetail.ApplicationNo }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Branch</h6>
      <p class="lead fs-12">{{ dvDetail.Branch }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Loan Product</h6>
      <p class="lead fs-12">{{ dvDetail.Product }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Borrower Name</h6>
      <p class="lead fs-12">{{ dvDetail.Customer }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Loan Amount</h6>
      <p class="lead fs-12">₹{{ dvDetail.LoanAmount }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Tenure ({{ Tenure_Name }})</h6>
      <p class="lead fs-12">{{ dvDetail.LoanTenure }} {{ Tenure_Name }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Loan No</h6>
      <p class="lead fs-12">{{ dvDetail.LoanNo }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Loan Date</h6>
      <p class="lead fs-12">{{ dvDetail.LoanDate }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">First EMI Date</h6>
      <p class="lead fs-12">{{ dvDetail.FirstEMIDate }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Emi Amount</h6>
      <p class="lead fs-12">{{ dvDetail.EMIAmount }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">No Of Inst</h6>
      <p class="lead fs-12">{{ dvDetail.NoOfInstallment }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">TAT</h6>
      <p class="lead fs-12">{{ dvDetail.TAT_Hr }} Hr.</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Voucher Status</h6>
      <p class="lead fs-12">{{ dvDetail.VoucherStatus }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Created On</h6>
      <p class="lead fs-12">{{ dvDetail.CreatedOn }}</p>
    </div>
    <div class="col-md-2">
      <h6 class="fs-12">Created By</h6>
      <p class="lead fs-12">{{ dvDetail.CreatedBy }}</p>
    </div>

    <div class="col-md-2">
      <h6 class="fs-12">Case IRR</h6>
      <p class="lead fs-12">{{ dvDetail.IRR | number : "1.2-2" }} %</p>
    </div>

    <div class="col-md-2">
      <h6 class="fs-12">ROI</h6>
      <p class="lead fs-12">{{ flat_ROI | number : "1.2-2" }} %</p>
    </div>

    <div class="col-md-2" *ngIf="dvDetail.VoucherStatus == 'Reverted'">
      <h6 class="fs-12">Reverted On</h6>
      <p class="lead fs-12">{{ dvDetail.RevertedOn }}</p>
    </div>
    <div class="col-md-2" *ngIf="dvDetail.VoucherStatus == 'Reverted'">
      <h6 class="fs-12">Reverted By</h6>
      <p class="lead fs-12">{{ dvDetail.RevertedBy }}</p>
    </div>
    <div class="col-md-4" *ngIf="dvDetail.VoucherStatus == 'Reverted'">
      <h6 class="fs-12">Remark</h6>
      <p class="lead fs-12">{{ dvDetail.Remark }}</p>
    </div>

    <div class="col-md-2" *ngIf="dvDetail.EMI_Type == 'SingleEMI'">
      <h6 class="fs-12">Net Disbursement Amount</h6>
      <p class="lead fs-12">
        {{ dvDetail.NetDisbursementAmount | number : "1.2-2" }}
      </p>
    </div>

    <div class="col-md-2" *ngIf="dvDetail.EMI_Type == 'SingleEMI'">
      <h6 class="fs-12">Total Deduction</h6>
      <p class="lead fs-12">
        {{ dvDetail.Total_Deduction | number : "1.2-2" }}
      </p>
    </div>

    <div class="col-md-2" *ngIf="dvDetail.EMI_Type == 'SingleEMI'">
      <h6 class="fs-12">Processing Fee(%)</h6>
      <p class="lead fs-12">
        {{ dvDetail.ProcessingFeePercentage | number : "1.2-2" }} %
      </p>
    </div>
  </div>

  <div class="row m-0 mb-2 col-md-12 p-0">
    <div class="table-responsive">
      <mat-table [dataSource]="dataSourceCustomerDetail">
        <ng-container matColumnDef="CustomerId">
          <mat-header-cell class="grid-header" style="max-width: 3.125rem" *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 3.125rem; max-height: 0.3125rem">
            {{ i + 1 }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Customer">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Customer
          </mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
            <app-lms-customer-view-model [customerId]="row.CustomerId" [index]="i">{{ row.Customer
              }}</app-lms-customer-view-model>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="CustomerType">
          <mat-header-cell class="grid-header" *matHeaderCellDef>Customer Type</mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">{{
            row.CustomerType == "Hirer" ? "Borrower" : row.CustomerType
            }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="GenderAge">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Gender Age
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.GenderAge }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="PhoneNo">
          <mat-header-cell class="grid-header" *matHeaderCellDef>Phone No</mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            <div *ngIf="currentUser.IsMaskingMobile">
              {{ row.PhoneNo | mask }}
            </div>

            <div *ngIf="!currentUser.IsMaskingMobile">
              {{ row.PhoneNo }}
            </div>

            <i *ngIf="row.PhoneNoIsVerified.toLowerCase() == 'true'" class="fa fa-check-circle ml-2"
              style="color: green"></i>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Relation_With_Hirer">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Relation With Hirer</mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.Relation_With_Hirer }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ExistingCustomer">
          <mat-header-cell class="grid-header" *matHeaderCellDef>
            Existing
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="grid-cell">
            {{ row.ExistingCustomer }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedCustomerDetailColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCustomerDetailColumns"></mat-row>
      </mat-table>
    </div>
  </div>

   <div class="row m-0 mb-2 mt-2 p-0" *ngIf="dataSourceAssetDetail?.data?.length > 0">
      <div class="col-md-12 p-0">
        <div class="table-responsive">
          <mat-table [dataSource]="dataSourceAssetDetail" matSort matTableExporter #exporter="matTableExporter"
            style="height: fit-content; max-width: 100%; overflow: auto">
            <ng-container matColumnDef="AssetId">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 6.25rem"
                *matHeaderCellDef>#</mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell"
                style="max-width: 6.25rem; max-height: 0.3125rem">
                {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Collateral_Type">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Collateral Type</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Collateral_Type }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Collateral">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Collateral</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.Collateral }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ValuationType">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Valuation Type</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.ValuationType }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ValuationAmount">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Valuation Amount</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.ValuationAmount }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ValuationDate">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Valuation Date</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                {{ row.ValuationDate }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="View_Detail">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>View Detail</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">
                <i class="fa fa-eye" style="font-size: large; cursor: pointer" (click)="ViewData(row)" aria-label="true"
                  [class.spinner]="loading"></i>
                <!-- <i class="fa fa-trash style-delete ml-2" (click)="Delete_AssetInfo(row)" *ngIf="
                    PageAcess &&
                    PageAcess[0].Delete == 1 &&
                    Status != 'C' &&
                    !loanSummary.CloseDate
                  " style="cursor: pointer" aria-label="true"></i> -->
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumnsAsset; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumnsAsset"></mat-row>
          </mat-table>

          <!-- <mat-paginator #paginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons>
          </mat-paginator> -->
        </div>
      </div>
    </div>

  <div class="row m-0 mb-4">
    <div class="tab row m-0 col-md-12 p-0">
      <div class="row m-0 col-md-6 pt-2 pb-2 align-items-center justify-content-center bdr"
        [ngClass]="{ active: tab == 'deduction' }" (click)="changeTab('deduction')">
        Deductions
      </div>
      <div class="row m-0 col-md-6 pt-2 pb-2 align-items-center justify-content-center bdr"
        [ngClass]="{ active: tab == 'receipt' }" (click)="changeTab('receipt')">
        Receipts
      </div>
    </div>

    <!-- deduction -->
    <div class="row m-0 col-md-12 p-0 mt-2" *ngIf="tab == 'deduction'">
      <div class="main-container row m-0 col-md-12 p-0">
        <form #f="ngForm" novalidate class="row m-0 col-md-12 p-0">
          <form #df="ngForm" novalidate class="row m-0 col-md-12 p-0 formborder">
            <div class="row m-0 mt-2 col-md-12 add-remove"
              *ngFor="let vdData of voucherModel.Voucher_Detail; let i = index">
              <div class="col-md-12 row m-0 type-column">
                <div class="type">
                  <span class="required-lable" *ngIf="i == 0">Type</span>
                  <select name="Type{{ i }}" id="Type{{ i }}" required disabled #refType="ngModel" [ngClass]="{
                      'is-invalid': df.submitted && refType.invalid,
                      'alert-warning':
                        refType.invalid &&
                        (refType.dirty || refType.touched || refType.untouched)
                    }" [(ngModel)]="vdData.Type" class="form-control pl-1 input-text-css"
                    (change)="onChangeCRDR(vdData)">
                    <option [value]="'DR'">DR</option>
                    <option [value]="'CR'">CR</option>
                  </select>
                </div>
                <div class="row m-0 feild">
                  <ng-container *ngIf="voucherModel.Voucher.Voucher_Sub_Type == 'Loan'">
                    <div class="col-md-2 pr-0">
                      <span class="" [ngClass]="{
                          'required-lable': vdData.IsLoanChargeable
                        }" *ngIf="i == 0">Loan/App No.</span>
                      <!-- <span class="" [ngClass]="{'required-lable':vdData.IsLoanChargeable}" *ngIf="i==0">Search</span> -->
                      <div class="input-btn">
                        <input type="text" [required]="vdData.IsLoanChargeable" readonly name="ApplicationNo{{ i }}"
                          id="ApplicationNo{{ i }}" [(ngModel)]="vdData.ApplicationNo"
                          class="form-control input-text-css" />
                        <!-- (keyup.enter)="searchCustomer(vdData,i)" -->
                        <button type="button" class="primary-btn ml-2 search">
                          <i class="fa fa-search" aria-hidden="true" style="font-size: 0.6875rem"></i>
                        </button>
                        <!-- (click)="vdData.isShowIcon && searchCustomer(vdData,i)" -->
                      </div>
                    </div>
                    <div class="col-md-2 pr-0">
                      <span *ngIf="i == 0">Customer</span>
                      <input type="text" name="Customer{{ i }}" id="Customer{{ i }}" class="form-control input-text-css"
                        readonly [(ngModel)]="vdData.Customer" />
                    </div>
                    <div class="col-md-2 pr-0">
                      <span *ngIf="i == 0">Branch</span>
                      <input type="text" name="Branch{{ i }}" id="Branch{{ i }}" class="form-control input-text-css"
                        readonly [(ngModel)]="vdData.Branch" />
                    </div>
                    <div class="col-md-2 pr-0">
                      <span class="" [ngClass]="{
                          'required-lable': vdData.IsLoanChargeable
                        }" *ngIf="i == 0">Category</span>
                      <select name="ChagesHeadId{{ i }}" id="ChagesHeadId{{ i }}" [required]="vdData.IsLoanChargeable"
                        #refChagesHeadId="ngModel" [ngClass]="{
                          'is-invalid': df.submitted && refChagesHeadId.invalid,
                          'alert-warning':
                            refChagesHeadId.invalid &&
                            (refChagesHeadId.dirty ||
                              refChagesHeadId.touched ||
                              refChagesHeadId.untouched)
                        }" [(ngModel)]="vdData.ChagesHeadId" class="form-control input-text-css" disabled>
                        <!-- (change)="onChangeChargesHead(vdData,i)" -->
                        <option value="">Select Category</option>
                        <option *ngFor="let item of chargesHeadDropdownData" [value]="item.Id">
                          {{ item.ChagesHead }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2 pr-0">
                      <span class="required-lable" *ngIf="i == 0">Account</span>

                      <input type="text" name="AccountId{{ i }}" id="AccountId{{ i }}"
                        class="form-control input-text-css" readonly [(ngModel)]="vdData.Account" />
                      <!--<select
    name="AccountId{{ i }}"
    id="AccountId{{ i }}"
    required
    #refAccountId="ngModel"
    [ngClass]="{
      'is-invalid': df.submitted && refAccountId.invalid,
      'alert-warning':
        refAccountId.invalid &&
        (refAccountId.dirty ||
          refAccountId.touched ||
          refAccountId.untouched)
    }"
    [(ngModel)]="vdData.AccountId"
    class="form-control input-text-css"
    (change)="onChangeAccountHead(vdData, i)"
    [attr.disabled]="
      (vdData.ChagesHeadId != '' ? true : false) &&
      vdData.isDisbled
    "
  >
    <option value="">Select Head</option>
    <option
      *ngFor="let item of accountHeadDropdown"
      [value]="item.AccountId"
    >
      {{ item.Account_Name }}
    </option>
  </select>-->
                    </div>
                    <div class="col-md-1 pr-0 pl-1">
                      <span class="" [ngClass]="{ 'required-lable': vdData.Type == 'DR' }"
                        *ngIf="i == 0">Amount(DR)</span>
                      <input type="number" min="0" name="Amount{{ i }}" id="Amount{{ i }}" *ngIf="vdData.Type == 'DR'"
                        class="form-control input-text-css text-right pr-3" [required]="vdData.Type == 'DR'"
                        #refAmount="ngModel" [ngClass]="{
                          'is-invalid': df.submitted && refAmount.invalid,
                          'alert-warning':
                            refAmount.invalid &&
                            (refAmount.dirty ||
                              refAmount.touched ||
                              refAmount.untouched)
                        }" [(ngModel)]="vdData.Amount" readonly />
                      <!-- (change)="onChangeAmount($event,vdData)" (keyup.enter)="onChangeAmount($event,vdData)" -->
                      <input type="number" name="AmountD{{ i }}" id="AmountD{{ i }}" readonly
                        class="form-control input-text-css text-right pr-3" *ngIf="vdData.Type == 'CR'" />
                    </div>
                    <div class="col-md-1 pr-0 pl-1">
                      <span class="" [ngClass]="{ 'required-lable': vdData.Type == 'CR' }"
                        *ngIf="i == 0">Amount(CR)</span>
                      <input type="number" min="0" name="Amount{{ i }}" *ngIf="vdData.Type == 'CR'" id="Amount{{ i }}"
                        class="form-control input-text-css text-right pr-3" [required]="vdData.Type == 'CR'"
                        #refAmount="ngModel" [ngClass]="{
                          'is-invalid': df.submitted && refAmount.invalid,
                          'alert-warning':
                            refAmount.invalid &&
                            (refAmount.dirty ||
                              refAmount.touched ||
                              refAmount.untouched)
                        }" [(ngModel)]="vdData.Amount" readonly />
                      <!--  (change)="onChangeAmount($event,vdData)" (keyup.enter)="onChangeAmount($event,vdData)"  [disabled]="vdData.IsLoanChargeable && !vdData.ChagesHeadId && vdData.isShowIcon" -->
                      <input type="number" name="AmountD{{ i }}" id="AmountD{{ i }}" readonly
                        class="form-control input-text-css text-right pr-3" *ngIf="vdData.Type == 'DR'" />
                    </div>
                  </ng-container>
                </div>
              </div>
              <ng-container *ngIf="vdData.TaxSlab && vdData.TaxSlab.length > 0">
                <div class="col-md-12 row m-0 p-0 mt-2" *ngFor="let taxData of vdData.TaxSlab; let ti = index">
                  <div class="col-md-2 pr-0">
                    <span><b>Slab :</b>&nbsp;{{ taxData.SlabName }}</span>
                  </div>
                  <div class="col-md-3 pr-0">
                    <span><b>Type :</b>&nbsp;{{ taxData.TaxType }} </span>
                  </div>
                  <div class="col-md-1 p-0">
                    <span><b>Rate :</b>&nbsp;{{ taxData.TaxPercentage }} %</span>
                  </div>
                  <div class="col-md-4 pr-0">
                    <span><b>Account :</b>&nbsp;{{ taxData.Account }}</span>
                  </div>
                  <div class="col-md-1 text-right pl-0 pr-3">
                    <span><b></b>&nbsp;<ng-container *ngIf="vdData.Type == 'DR' && taxData.Amount">{{ taxData.Amount }}
                      </ng-container></span>
                  </div>
                  <div class="col-md-1 text-right pl-1 pr-3">
                    <span><b></b>&nbsp;<ng-container *ngIf="vdData.Type == 'CR' && taxData.Amount">{{ taxData.Amount }}
                      </ng-container></span>
                  </div>
                </div>
              </ng-container>

              <button type="button" class="remove" (click)="removeData(i, vdData)" [ngClass]="{ 'no-head': i != 0 }"
                *ngIf="
                  i != voucherModel.Voucher_Detail.length - 1 &&
                  i != 0 &&
                  voucherModel.Voucher_Detail[i].Id!=0 &&
                  (dvDetail.VoucherStatus == 'Pending' ||
                    dvDetail.VoucherStatus == 'Reverted' ||
                    DVEdit == 'true')
                    && voucherModel.Voucher_Detail[i].DeductionType!='AutoDeduction'
                ">
                -
              </button>
              <button type="button" class="addmore" (click)="addMoreData()" [ngClass]="{
                  both: voucherModel.Voucher_Detail.length > 0,
                  'no-head': i != 0
                }" [disabled]="!df.form.valid" *ngIf="
                  i == voucherModel.Voucher_Detail.length - 1 &&
                  !vdData.IsTax &&
                  (dvDetail.VoucherStatus == 'Pending' ||
                    dvDetail.VoucherStatus == 'Reverted' ||
                    DVEdit == 'true')
                ">
                +
              </button>
            </div>

            <div class="col-md-12 row m-0 pr-5 mt-2 mb-2"
              *ngIf="totalCalculator && voucherModel.Voucher_Detail.length > 0">
              <div class="pr-0" [ngClass]="{
                  'col-md-10': voucherModel.Voucher.Voucher_Sub_Type == 'Loan',
                  'col-md-8':
                    voucherModel.Voucher.Voucher_Sub_Type == 'Accounting'
                }">
                <span><b>Grand Total :</b></span>
              </div>
              <div class="text-right pr-1" [ngClass]="{
                  'col-md-1': voucherModel.Voucher.Voucher_Sub_Type == 'Loan',
                  'col-md-2':
                    voucherModel.Voucher.Voucher_Sub_Type == 'Accounting'
                }">
                <span>{{ totalCalculator.totalDR.toFixed(2) }}</span>
              </div>
              <div class="text-right pr-1" [ngClass]="{
                  'col-md-1': voucherModel.Voucher.Voucher_Sub_Type == 'Loan',
                  'col-md-2':
                    voucherModel.Voucher.Voucher_Sub_Type == 'Accounting'
                }">
                <span>{{ totalCalculator.totalCR.toFixed(2) }}</span>
              </div>
            </div>
          </form>
          <div class="row m-0 mt-3 mb-2 col-md-12 formborder" *ngIf="voucherModel.Voucher_Detail.length > 0">
            <div class="col-md-12">
              <span class="">Voucher Narration</span>
              <input type="text" #refVoucher_Narration="ngModel" [ngClass]="{
                  'is-invalid': f.submitted && refVoucher_Narration.invalid,
                  'alert-warning':
                    refVoucher_Narration.invalid &&
                    (refVoucher_Narration.dirty ||
                      refVoucher_Narration.touched ||
                      refVoucher_Narration.untouched)
                }" [(ngModel)]="voucherModel.Voucher.Voucher_Narration" name="Voucher_Narration" id="Voucher_Narration"
                class="form-control input-text-css" [disabled]="
                  !(
                    dvDetail.VoucherStatus == 'Pending' ||
                    dvDetail.VoucherStatus == 'Reverted' ||
                    DVEdit == 'true'
                  )
                " />
            </div>
          </div>
          <div class="row col-md-12 m-0 mt-2 mb-2 justify-content-end" *ngIf="
              voucherModel.Voucher_Detail.length > 0 &&
              (dvDetail.VoucherStatus == 'Pending' ||
                dvDetail.VoucherStatus == 'Reverted' ||
                DVEdit == 'true')
            ">
            <div class="col-md-4">
              <button type="button" class="mt-3 btn font-size-12 button-btn" (click)="OnClickTrackLoan()">
                Customer Loan Track
              </button>
            </div>
            <div class="col-md-4">
              <button type="button" class="mt-3 btn font-size-12 button-btn" (click)="OnClickAutoDvDeduction()">
                Auto Dv Deduction Detail
              </button>
            </div>
            <div class="col-md-4 text-right">
              <button type="button" class="ml-4 mt-3 btn font-size-12 button-btn" (click)="saveVoucher()"
                [class.spinner]="loading" [disabled]="!f.form.valid || !df.form.valid">
                Save
              </button>
              <button type="button" (click)="closeDisDetail()" class="ml-4 mt-3 btn font-size-12 button-btn">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- receipt -->
    <div class="row m-0 col-md-12 p-0 mt-2" *ngIf="tab == 'receipt'">
      <div class="table-responsive">
        <mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="Id">
            <mat-header-cell class="grid-header" style="max-width: 3.125rem" *matHeaderCellDef>#</mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 3.125rem; max-height: 0.3125rem">
              {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Type">
            <mat-header-cell class="grid-header" *matHeaderCellDef>Type</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Type }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ApplicationNo">
            <mat-header-cell class="grid-header" *matHeaderCellDef>Application No</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.ApplicationNo }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ChagesHead">
            <mat-header-cell class="grid-header" *matHeaderCellDef>ChagesHead</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.ChagesHead }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Account">
            <mat-header-cell class="grid-header" *matHeaderCellDef>
              Account
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Account }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="TaxPercentage">
            <mat-header-cell class="grid-header" *matHeaderCellDef>Tax(%)</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.TaxPercentage }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Amount">
            <mat-header-cell class="grid-header" *matHeaderCellDef>Amount</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Amount }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="CollectionOn">
            <mat-header-cell class="grid-header" *matHeaderCellDef>
              CollectionOn
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.CollectionOn }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="CollectionBy">
            <mat-header-cell class="grid-header" *matHeaderCellDef>
              CollectionBy
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.CollectionBy }}
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
        <mat-paginator #paginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons>
        </mat-paginator>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in" id="dvDetailNewDeduction" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          New Deduction
        </h6>
        <button type="button" class="close" (click)="OnCloseSearchNew()" aria-label="Close">
          <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row m-0 mt-3">
          <form #snf="ngForm" class="col-md-12" novalidate>
            <div class="row m-0 col-md-12 p-0 mt-3 add-remove">
              <div class="col-md-12 p-0 row m-0 type-column">
                <div class="row m-0 col-md-12 p-0 feild">
                  <ng-container>
                    <div class="col-md-2 pr-0">
                      <span class="required-lable">Search</span>
                      <div class="input-btn">
                        <input required type="text" readonly name="CaseNo" id="CaseNo"
                          [(ngModel)]="Voucher_Detail_NEW_DEDUCTION.CaseNo" class="form-control input-text-css"
                          (keyup.enter)="searchCustomer()" />
                        <button type="button" (click)="searchCustomer()" class="primary-btn ml-2 search">
                          <i class="fa fa-search" aria-hidden="true" style="font-size: 0.6875rem"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-2 pr-0">
                      <span>Customer</span>
                      <input type="text" name="Customer" id="Customer" class="form-control input-text-css" readonly
                        [(ngModel)]="Voucher_Detail_NEW_DEDUCTION.Customer" />
                    </div>
                    <div class="col-md-2 pr-0">
                      <span>Branch</span>
                      <input type="text" name="Branch_Name" id="Branch_Name" class="form-control input-text-css"
                        readonly [(ngModel)]="Voucher_Detail_NEW_DEDUCTION.Branch_Name" />
                    </div>
                    <div class="col-md-2 pr-0">
                      <span class="required-lable">Category</span>
                      <select name="ChargeHeadId" id="ChargeHeadId" required #refChargeHeadId="ngModel" [ngClass]="{
                          'is-invalid':
                            snf.submitted && refChargeHeadId.invalid,
                          'alert-warning':
                            refChargeHeadId.invalid &&
                            (refChargeHeadId.dirty ||
                              refChargeHeadId.touched ||
                              refChargeHeadId.untouched)
                        }" [(ngModel)]="Voucher_Detail_NEW_DEDUCTION.ChargeHeadId" class="form-control input-text-css"
                        (change)="
                          onChangeChargesHead(Voucher_Detail_NEW_DEDUCTION)
                        " [disabled]="!Voucher_Detail_NEW_DEDUCTION.ProductId">
                        <option value="">Select Category</option>
                        <ng-container *ngFor="let item of chargesHeadDropdown">
                          <option [value]="item.Id" *ngIf="item.Id != 27 && item.Id != 28">
                            {{ item.ChagesHead }}
                          </option>
                        </ng-container>
                      </select>
                    </div>
                    <div class="col-md-2 pr-0">
                      <span> Account Head</span>
                      <input type="text" name="ChargeHeadCategory" id="ChargeHeadCategory"
                        class="form-control input-text-css" readonly [(ngModel)]="
                          Voucher_Detail_NEW_DEDUCTION.ChargeHeadCategory
                        " />
                    </div>
                    <div class="col-md-2">
                      <span class="required-lable">Amount</span>
                      <input type="number" min="0" name="Amount" id="Amount"
                        [disabled]="!Voucher_Detail_NEW_DEDUCTION.ChargeHeadId"
                        class="form-control input-text-css text-right pr-3" required #refAmount="ngModel" (change)="
                          onChangeAmount($event, Voucher_Detail_NEW_DEDUCTION)
                        " (keyup.enter)="
                          onChangeAmount($event, Voucher_Detail_NEW_DEDUCTION)
                        " [ngClass]="{
                          'is-invalid': snf.submitted && refAmount.invalid,
                          'alert-warning':
                            refAmount.invalid &&
                            (refAmount.dirty ||
                              refAmount.touched ||
                              refAmount.untouched)
                        }" [(ngModel)]="Voucher_Detail_NEW_DEDUCTION.Amount" />
                    </div>
                  </ng-container>
                </div>
              </div>
              <ng-container *ngIf="
                  Voucher_Detail_NEW_DEDUCTION.TaxSlab &&
                  Voucher_Detail_NEW_DEDUCTION.TaxSlab.length > 0
                ">
                <div class="col-md-12 row m-0 p-0 mt-2" *ngFor="
                    let taxData of Voucher_Detail_NEW_DEDUCTION.TaxSlab;
                    let ti = index
                  ">
                  <div class="col-md-2 pr-0">
                    <span><b>Slab :</b>&nbsp;{{ taxData.SlabName }}</span>
                  </div>
                  <div class="col-md-3 pr-0">
                    <span><b>Type :</b>&nbsp;{{ taxData.TaxType }} </span>
                  </div>
                  <div class="col-md-2 pr-0">
                    <span><b>Rate :</b>&nbsp;{{ taxData.TaxRate }} %</span>
                  </div>
                  <div class="col-md-3 pr-0">
                    <span><b>Account Head :</b>&nbsp;{{
                      taxData.TaxAccountName
                      }}</span>
                  </div>
                  <div class="col-md-2 text-right pr-5">
                    <!--<span><b></b>&nbsp;<ng-container *ngIf="taxData.TaxAmount">{{taxData.TaxAmount}}</ng-container></span>-->
                    <input type="text" *ngIf="taxData.TaxAmount" name="TaxAmount{{ ti }}" id="TaxAmount{{ ti }}"
                      [(ngModel)]="taxData.TaxAmount" class="form-control input-text-css"
                      (change)="getTotalCalculationNew()" />
                    <!-- <input type="text" *ngIf="taxData.TaxAmount" name="TaxAmount{{ i }}{{ti}}" id="TaxAmount{{ i }}{{ti}}"
                           [(ngModel)]="taxData.TaxAmount" class="form-control input-text-css" (change)="getTotalCalculationNew()" /> -->
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="col-md-12 row m-0 p-0 pr-4 mt-2" *ngIf="totalCalculatorNewDeduction">
              <div class="col-md-8 pr-0">
                <span><b>Grand Total :</b></span>
              </div>
              <div class="col-md-4 text-right pr-1">
                <span><b>In Digit :</b>&nbsp;{{
                  totalCalculatorNewDeduction.total.toFixed(2)
                  }}</span>
              </div>
            </div>

            <div class="row col-md-12 m-0 mt-3 justify-content-end">
              <button type="button" (click)="OnCloseSearchNew()" class="btn btn-light font-size-12 mr-3">
                Cancel
              </button>
              <button type="button" (click)="onSaveNewRdDetail()" class="btn font-size-12 button-btn"
                [class.spinner]="loading" [disabled]="!snf.form.valid">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in" id="dvDetailCustomerReceipt" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Search
        </h6>
        <button type="button" class="close" (click)="OnCloseSearch()" aria-label="Close">
          <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <!--<div class="row m-0 mt-3">
          <form #sf="ngForm" class="col-md-12" novalidate>
            <div class="row m-0 ">
              <div class="col-md-12">
                <span class="">Search On</span>
                <div class="row m-0 col-md-12 p-0">
                  <div class="col-md-6">
                    <span class="form-check-inline">
                      <label class="form-check-label" for="Is_LOSAppliaction0">
                        <input type="radio" class="form-check-input" id="Is_LOSAppliaction0" name="Is_LOSAppliaction"
                          [(ngModel)]="Voucher_Detail_NEW_DEDUCTION.Is_LOSAppliaction" required value="0" />
                        Loan No
                      </label>
                    </span>
                  </div>-->
        <!-- <div class="col-md-6">
                    <span class="form-check-inline">
                      <label class="form-check-label" for="Is_LOSAppliaction1">
                        <input type="radio" class="form-check-input" id="Is_LOSAppliaction1" name="Is_LOSAppliaction"
                          [(ngModel)]="selectedData.Is_LOSAppliaction" required value="1" />
                        Application No
                      </label>
                    </span>
                  </div> -->
        <!--</div>
              </div>
              <div class="col-md-6">
                <span>Value </span>
                <input type="text" required name="SearchValue" id="SearchValue" #refSearchValue="ngModel"
                  [ngClass]="{ 'is-invalid': sf.submitted && refSearchValue.invalid, 'alert-warning': refSearchValue.invalid  && (refSearchValue.dirty || refSearchValue.touched || refSearchValue.untouched) }"
                  [(ngModel)]="Voucher_Detail_NEW_DEDUCTION.SearchValue" class="form-control input-text-css"
                  (keyup.enter)="Get_Acc_Search_LoanNo()" />
              </div>
              <div class="row col-md-6 m-0 align-items-center">
                <button type="button" class="mt-3" style="background-color: #28a745; color: #ffffff; font-size: 0.75rem"
                  mat-raised-button color="primary" (click)="Get_Acc_Search_LoanNo()" [class.spinner]="loading"
                  [disabled]="!sf.form.valid">
                  Search
                </button>
              </div>
            </div>
            <div class="row m-o mt-3">
              <div class="col-md-12">
                <mat-table [dataSource]="dataSourcePop">
                  <ng-container matColumnDef="LoanId">
                    <mat-header-cell class="grid-header" style="max-width: 3.125rem" *matHeaderCellDef>#</mat-header-cell>
                    <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 3.125rem; max-height: 0.3125rem">{{ i + 1 }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="LoanNo">
                    <mat-header-cell class="grid-header" *matHeaderCellDef>Application/Loan No</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.LoanNo }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Product_Name">
                    <mat-header-cell class="grid-header" *matHeaderCellDef>Product Name</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Product_Name }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Customer">
                    <mat-header-cell class="grid-header" *matHeaderCellDef>Customer</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Customer }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="PhoneNo">
                    <mat-header-cell class="grid-header" *matHeaderCellDef>PhoneNo</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.PhoneNo }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Branch_Name">
                    <mat-header-cell class="grid-header" *matHeaderCellDef>Branch</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Branch_Name }}</mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="Action">
                    <mat-header-cell class="grid-header" style="max-width: 4.6875rem" *matHeaderCellDef>Action</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="grid-cell " style="max-width: 4.6875rem">
                      <button type="button" class="" style="background-color: #28a745; color: #ffffff; font-size: 0.75rem"
                        mat-raised-button color="primary" (click)="selectSearchData(row)">
                        Select
                      </button>
                    </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="displayedColumnsPop"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumnsPop" style="cursor: pointer"></mat-row>
                </mat-table>
              </div>
            </div>
          </form>

          <div class="row col-md-12 m-0 mt-3 justify-content-end">
            <button type="button" class="btn btn-light font-size-12" (click)="OnCloseSearch()">
              Close
            </button>
          </div>
        </div>-->

        <form #f="ngForm" (ngSubmit)="onSearchCustomerDetail()" novalidate class="row m-0 col-md-12 p-0">
          <div class="row m-0 col-md-12 p-0">
            <!--<div class="col-md-3">
              <span>Type</span>
              <select name="Type" id="Type" class="form-control input-text-css" [(ngModel)]="Type">
                <option [value]="0">All</option>
                <option [value]="1">LOS Only</option>
                <option [value]="2">LMS Only</option>
              </select>
            </div>-->
            <div class="col-md-3">
              <span>Application No.</span>
              <input name="SApplicationNo" [(ngModel)]="Customer.ApplicationNo" id="SApplicationNo"
                placeholder="Application No." class="form-control input-text-css" />
            </div>
            <div class="col-md-3">
              <span>Loan No.</span>
              <input name="SLoanNo" [(ngModel)]="Customer.LoanNo" id="SLoanNo" placeholder="Loan No."
                class="form-control input-text-css" />
            </div>
            <div class="col-md-3">
              <span>Customer Name</span>
              <input name="CustomerName" [(ngModel)]="Customer.CustomerName" id="CustomerName"
                placeholder="Customer Name" class="form-control input-text-css" />
            </div>
            <div class="col-md-3">
              <span>Customer Phone</span>
              <input name="CustomerPhone" [(ngModel)]="Customer.CustomerPhone" id="CustomerPhone"
                placeholder="Customer Phone" class="form-control input-text-css" />
            </div>
            <div class="col-md-3">
              <span>PAN Card</span>
              <input name="PANCard" [(ngModel)]="Customer.PANCard" id="PANCard" placeholder="PAN Card"
                class="form-control input-text-css" />
            </div>
            <div class="col-md-3">
              <span>Passport No.</span>
              <input name="Passport" [(ngModel)]="Customer.Passport" id="Passport" placeholder="Passport No."
                class="form-control input-text-css" />
            </div>
            <div class="col-md-3">
              <span>Voter ID Card</span>
              <input name="VoterID" [(ngModel)]="Customer.VoterID" id="VoterID" placeholder="Voter ID Card"
                class="form-control input-text-css" />
            </div>
            <div class="col-md-3">
              <span>Driving License</span>
              <input name="DL" [(ngModel)]="Customer.DL" id="DL" placeholder="Driving License"
                class="form-control input-text-css" />
            </div>
            <div class="col-md-3">
              <span>Aadhaar Card</span>
              <input name="Aadhaar" [(ngModel)]="Customer.Aadhaar" id="Aadhaar" placeholder="Aadhaar Card"
                class="form-control input-text-css" />
            </div>
          </div>
          <div class="row m-0 col-md-12 p-0 justify-content-end">
            <button type="button" (click)="onSearchCustomerDetail()" class="btn font-size-12 button-btn">
              Search
            </button>
          </div>
        </form>

        <div class="table-responsive mt-3">
          <mat-table [dataSource]="dataSourceCustomer" #sortList="matSort" matSort id="exportReport">
            <ng-container matColumnDef="CustomerId">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 3.125rem" *matHeaderCellDef>
                #
              </mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="max-width: 3.125rem; max-height: 0.3125rem">
                {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Type">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 9.375rem; justify-content: center"
                *matHeaderCellDef>
                Type
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 9.375rem; justify-content: center">{{
                row.Type }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Application_No">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 9.375rem; justify-content: center"
                *matHeaderCellDef>
                Aplication No
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 9.375rem; justify-content: center">
                {{ row.Application_No }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="LoanAcNo">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 9.375rem; justify-content: center"
                *matHeaderCellDef>
                Loan No
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 9.375rem; justify-content: center">
                {{ row.LoanAcNo }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="CustomertName">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Customer</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{ row.CustomertName }}({{ row.AC_CustomerType
                }})</mat-cell>
            </ng-container>

            <ng-container matColumnDef="FatherName">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Relation Name</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell">{{
                row.FatherName
                }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="Customer_Gender">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 3.125rem"
                *matHeaderCellDef>Gender</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 3.125rem">{{ row.Customer_Gender
                }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="GenderAge">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 3.125rem"
                *matHeaderCellDef>Age</mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 3.125rem">{{ row.GenderAge }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="PhoneNo">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 9.375rem; justify-content: center"
                *matHeaderCellDef>
                Phone No
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell" style="max-width: 9.375rem; justify-content: center">
                {{ row.PhoneNo }}
                <i *ngIf="row.Customer_PhoneNo_IsVerified == true" class="fa fa-check-circle ml-2"
                  style="color: green"></i>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="EditAction">
              <mat-header-cell mat-sort-header class="grid-header" style="max-width: 6.25rem; justify-content: center"
                *matHeaderCellDef>
                View Detail
              </mat-header-cell>
              <mat-cell *matCellDef="let row" class="grid-cell j-c-center" style="max-width: 3.75rem">
                <i class="fas fa-lg fa-edit margin-right-4xs cursor-style" (click)="selectSearchData(row)"
                  aria-label="true"></i>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedCustomerColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedCustomerColumns"></mat-row>
          </mat-table>
          <mat-paginator #paginatorRef #PaginatorList [pageSizeOptions]="[20, 50]" showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in" id="LoanTrack" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Customer Loan Track
        </h6>
        <button type="button" class="close" (click)="CloseTrackLoan()" aria-label="Close">
          <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-bordered">
            <ng-container *ngFor="let Cdata of CustomerTrackList; let i = index">
              <thead>
                <tr class="grid-cell">
                  <th class="bg-success1">#</th>
                  <th class="bg-success1">CustomerId</th>
                  <th class="bg-success1">Customer</th>
                  <th class="bg-success1">Phone No.</th>
                  <th class="bg-success1" colspan="8">Present Address</th>
                  <th class="bg-success1" colspan="3">Gender/Age</th>
                </tr>
              </thead>
              <tr class="grid-cell">
                <td>{{ i + 1 }}</td>
                <td>{{ Cdata.CustomerId }}</td>
                <td>{{ Cdata.Customer }}</td>
                <td>
                  <div *ngIf="currentUser.IsMaskingMobile">
                    {{ Cdata.Customer_PhoneNo | mask }}
                  </div>

                  <div *ngIf="!currentUser.IsMaskingMobile">
                    {{ Cdata.Customer_PhoneNo }}
                  </div>
                </td>
                <td colspan="8">{{ Cdata.Present_Address }}</td>
                <td colspan="3">
                  {{ Cdata.Customer_Gender == "M" ? "Male" : "Female" }}
                </td>
              </tr>
              <tr>
                <th class="bg-success1" colspan="15">Loan Details :</th>
              </tr>
              <thead>
                <tr class="grid-cell">
                  <th>Loan A/C No.</th>
                  <th>Customer Type</th>
                  <th>Product Name</th>
                  <th>Total EMI</th>
                  <th>Total EMI Amount</th>
                  <th>Mature EMI</th>
                  <th>Mature EMI Amount</th>
                  <th>Remaining EMI</th>
                  <th>Remaining EMI Amount</th>
                  <th>Received EMI</th>
                  <th>Received EMI Amount</th>
                  <th>OD Balnce</th>
                  <th>Other Dues</th>
                  <th>POS</th>
                  <th>Status</th>
                </tr>
              </thead>
              <ng-container *ngFor="let CList of CustomerLoanList; let i = index">
                <tr class="grid-cell" *ngIf="Cdata.CustomerId == CList.CustomerId">
                  <td>
                    {{
                    CList.LoanAcNo == null
                    ? CList.ApplicationNo
                    : CList.LoanAcNo
                    }}
                  </td>
                  <td>
                    {{
                    CList.AC_CustomerType == "H"
                    ? "Borrower"
                    : CList.AC_CustomerType == "C"
                    ? "Co-Borrower"
                    : "Guaranter"
                    }}
                  </td>
                  <td>{{ CList.Product_Name }}</td>
                  <td>{{ CList.TotalEMI }}</td>
                  <td>{{ CList.TotalEMI_Amount }}</td>
                  <td>{{ CList.MatureEMI }}</td>
                  <td>{{ CList.MatureEMI_Amount }}</td>
                  <td>{{ CList.Remaining_EMI }}</td>
                  <td>{{ CList.Remaining_EMI_Amount }}</td>
                  <td>{{ CList.Received_EMI }}</td>
                  <td>{{ CList.Received_EMI_Amount }}</td>
                  <td>{{ CList.ODBalnce }}</td>
                  <td>{{ CList.OtherDues }}</td>
                  <td>{{ CList.POS }}</td>
                  <td>{{ CList.Loan_Status }}</td>
                </tr>
              </ng-container>
              <tr>
                <td colspan="15">&nbsp;</td>
              </tr>
            </ng-container>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade in" id="DVDeduction" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          DV Auto Deduction
        </h6>
        <button type="button" class="close" (click)="CloseDVDeduction()" aria-label="Close">
          <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <table class="table table-bordered">
            <ng-container>
              <thead>
                <tr class="grid-cell">
                  <th class="bg-success1">#</th>
                  <th class="bg-success1">Chages Head</th>
                  <th class="bg-success1">Standard Deduction</th>
                  <th class="bg-success1">Received Amount</th>
                  <th class="bg-success1">deductible Amount</th>
                </tr>
              </thead>
              <tr class="grid-cell" *ngFor="let Cdata of LMS_Get_DV_Deduction; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ Cdata.ChagesHead }}</td>
                <td>{{ Cdata.TotalDeduction_Amount }}</td>
                <td>{{ Cdata.ReceivedAmount }}</td>
                <td>{{ Cdata.Deduct }}</td>

              </tr>

            </ng-container>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in" id="View" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content modern-modal">
      <!-- Modern Header -->
      <div cdkDragHandle class="modal-header modern-header">
        <div class="header-content">
          <span class="collateral-badge">{{ Collateral }}</span>
          <h5 class="modal-title">{{ Collateral_Type }}</h5>
        </div>
        <button type="button" (click)="onCloseView()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>

      <div class="modal-body modern-body">
        <!-- Vehicle Section -->
        <ng-container *ngIf="Collateral == 'Vehicle'">
          <div class="info-card" *ngIf="Info">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-car"></i>
                {{ Info.Vehicle_SubType }} Vehicle Details
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.VehicleManufacture">
                <label>Vehicle Manufacture</label>
                <p>{{ Info.VehicleManufacture }}</p>
              </div>
              <div class="info-item" *ngIf="Info.VehicleCategory">
                <label>Vehicle Category</label>
                <p>{{ Info.VehicleCategory }}</p>
              </div>
              <div class="info-item" *ngIf="Info.VehicleModelName">
                <label>Model Name</label>
                <p>{{ Info.VehicleModelName }}</p>
              </div>
              <div class="info-item" *ngIf="Info.VariantName">
                <label>Variant</label>
                <p>{{ Info.VariantName }}</p>
              </div>
              <div class="info-item" *ngIf="Info.MefgYear">
                <label>Manufacturing Year</label>
                <p>{{ Info.MefgYear }}</p>
              </div>
              <div class="info-item" *ngIf="Info.VehicleRegistationNo">
                <label>Registration No</label>
                <p>
                  {{ Info.VehicleRegistationNo }}
                  <i *ngIf="Info.VehicleRegistationNo != '' && (RCKYC_IsVerified == 1 || RCLastVerfiedDate)" 
                     class="fas fa-check-circle verified-icon"></i>
                </p>
              </div>
              <div class="info-item" *ngIf="Info.RegistationDate">
                <label>Registration Date</label>
                <p>{{ Info.RegistationDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.RegistationExpiryDate">
                <label>Registration Expiry</label>
                <p>{{ Info.RegistationExpiryDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.FuelType">
                <label>Fuel Type</label>
                <p>{{ Info.FuelType }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.RoadTaxUpto">
                <label>Road Tax Upto</label>
                <p>{{ Info.RoadTaxUpto }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Color">
                <label>Color</label>
                <p>{{ Info.Color }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.FitnessUpto">
                <label>Fitness Upto</label>
                <p>{{ Info.FitnessUpto }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.PermitUpto">
                <label>Permit Upto</label>
                <p>{{ Info.PermitUpto }}</p>
              </div>
              <div class="info-item" *ngIf="Info.VehicleCost">
                <label>Vehicle Cost</label>
                <p class="amount">{{ Info.VehicleCost }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Vehicle_SubType == 'Commercial' && Info.Rout">
                <label>Route</label>
                <p>{{ Info.Rout }}</p>
              </div>
              <div class="info-item" *ngIf="Info.EngineNo">
                <label>Engine No</label>
                <p>{{ Info.EngineNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ChassisNo">
                <label>Chassis No</label>
                <p>{{ Info.ChassisNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.KeyNo">
                <label>Key No</label>
                <p>{{ Info.KeyNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.RC_HPNEndorsment !== undefined && Info.RC_HPNEndorsment !== null">
                <label>RC HPN Endorsement</label>
                <p>
                  <span class="status-badge" [class.status-yes]="Info.RC_HPNEndorsment" 
                        [class.status-no]="!Info.RC_HPNEndorsment">
                    {{ Info.RC_HPNEndorsment == true ? "YES" : "NO" }}
                  </span>
                </p>
              </div>
              <div class="info-item" *ngIf="Info.Vehicle_Type == 'New' && Info.Invoice_HPNEndorsment !== undefined && Info.Invoice_HPNEndorsment !== null">
                <label>Invoice HPN Endorsement</label>
                <p>
                  <span class="status-badge" [class.status-yes]="Info.Invoice_HPNEndorsment" 
                        [class.status-no]="!Info.Invoice_HPNEndorsment">
                    {{ Info.Invoice_HPNEndorsment == true ? "YES" : "NO" }}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <!-- Price Description -->
          <div class="info-card" *ngIf="Info && (Info.ExShowroom || Info.Gst || Info.Insurance || Info.Tds_Tcs || Info.Accessories || Info.EssentialKit || Info.Transportation || Info.RTO || Info.OnRoad || Info.Earting || Info.Others)">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-rupee-sign"></i>
                Price Breakdown
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.ExShowroom">
                <label>Ex Showroom</label>
                <p class="amount">{{ Info.ExShowroom }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Gst">
                <label>GST</label>
                <p class="amount">{{ Info.Gst }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Insurance">
                <label>Insurance</label>
                <p class="amount">{{ Info.Insurance }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Tds_Tcs">
                <label>TDS/TCS</label>
                <p class="amount">{{ Info.Tds_Tcs }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Accessories">
                <label>Accessories</label>
                <p class="amount">{{ Info.Accessories }}</p>
              </div>
              <div class="info-item" *ngIf="Info.EssentialKit">
                <label>Essential Kit</label>
                <p class="amount">{{ Info.EssentialKit }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Transportation">
                <label>Transportation</label>
                <p class="amount">{{ Info.Transportation }}</p>
              </div>
              <div class="info-item" *ngIf="Info.RTO">
                <label>RTO</label>
                <p class="amount">{{ Info.RTO }}</p>
              </div>
              <div class="info-item" *ngIf="Info.OnRoad">
                <label>On Road</label>
                <p class="amount">{{ Info.OnRoad }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Earting">
                <label>Earthing</label>
                <p class="amount">{{ Info.Earting }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Others">
                <label>Others</label>
                <p class="amount">{{ Info.Others }}</p>
              </div>
            </div>
          </div>

          <!-- Used Vehicle Details -->
          <div class="info-card" *ngIf="Info && Info.Vehicle_Type == 'Used'">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-clipboard-check"></i>
                Used Vehicle Details 
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.ValuationDoneBy">
                <label>Valuation Done By</label>
                <p>{{ Info.ValuationDoneBy }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationDate">
                <label>Valuation Date</label>
                <p>{{ Info.ValuationDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationAmount">
                <label>Valuation Amount</label>
                <p class="amount">{{ Info.ValuationAmount }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationType">
                <label>Valuation Type</label>
                <p>{{ Info.ValuationType }}</p>
              </div>
              <div class="info-item" *ngIf="Info.OtherValuationType">
                <label>Other Valuation Type</label>
                <p>{{ Info.OtherValuationType }}</p>
              </div>
              <div class="info-item" *ngIf="Info.OtherValuationAmt">
                <label>Other Valuation Amount</label>
                <p class="amount">{{ Info.OtherValuationAmt }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationRemarkDoc">
                <label>Valuation Report</label>
                <p>
                  <a href="{{ applicationDocUrl }}{{ ApplicationNo.ApplicationNo }}/{{ Info.ValuationRemarkDoc }}" 
                     target="_blank" class="doc-link">
                    <i class="fas fa-file-pdf"></i>
                    {{ Info.ValuationRemarkDoc }}
                  </a>
                </p>
              </div>
              <div class="info-item" *ngIf="Info.SearchReportRemarkDoc">
                <label>Search Report</label>
                <p>
                  <a href="{{ applicationDocUrl }}{{ ApplicationNo.ApplicationNo }}/{{ Info.SearchReportRemarkDoc }}" 
                     target="_blank" class="doc-link">
                    <i class="fas fa-file-pdf"></i>
                    {{ Info.SearchReportRemarkDoc }}
                  </a>
                </p>
              </div>
            </div>
          </div>

          <!-- New Vehicle Details -->
          <div class="info-card" *ngIf="Info && Info.Vehicle_Type == 'New'">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-store"></i>
                New Vehicle Details
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.DealerName">
                <label>Dealer</label>
                <p>{{ Info.DealerName }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DealerContactPerson">
                <label>Contact Person</label>
                <p>{{ Info.DealerContactPerson }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DealerContactNo">
                <label>Contact No.</label>
                <p>{{ Info.DealerContactNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DONo">
                <label>DO. No.</label>
                <p>{{ Info.DONo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DODoDate">
                <label>DO. Date</label>
                <p>{{ Info.DODoDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.EstimationAmount">
                <label>Estimation Amount</label>
                <p class="amount">{{ Info.EstimationAmount }}</p>
              </div>
              <div class="info-item" *ngIf="Info.InvoiceNo">
                <label>Invoice No.</label>
                <p>{{ Info.InvoiceNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.InvoiceDate">
                <label>Invoice Date</label>
                <p>{{ Info.InvoiceDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.InvoiceValue">
                <label>Invoice Value</label>
                <p class="amount">{{ Info.InvoiceValue }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DOIssuedinfavourof">
                <label>Quotation in favour of</label>
                <p>{{ Info.DOIssuedinfavourof }}</p>
              </div>
              <div class="info-item info-item-full" *ngIf="Info.Remark">
                <label>Remark</label>
                <p>{{ Info.Remark }}</p>
              </div>
            </div>
          </div>

          <!-- Vehicle Images -->
          <div class="info-card" *ngIf="AssetsAttachment && AssetsAttachment.length > 0">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-images"></i>
                Uploaded Images
              </h2>
            </div>

            <div class="attachments-list">
              <div class="attachment-item" *ngFor="let report of AssetsAttachment; let i = index">
                <span class="attachment-index">{{ i + 1 }}</span>
                <span class="attachment-title">{{ report.Title }}</span>
                <a href="{{ applicationDocUrl }}{{ ApplicationNo.ApplicationNo }}/{{ report.DocFileName }}" 
                   target="_blank" *ngIf="report.DocFileName" class="attachment-link">
                  <i class="fas fa-external-link-alt"></i>
                  {{ report.DocFileName }}
                </a>
              </div>
            </div>
          </div>
          
          <!-- <div class="text-right mb-2" style="margin-right: 3.125rem">
            <button type="button" (click)="editAssetInfo(Info.AssetId)" *ngIf="
                Info && Info.AssetId && PageAcess && PageAcess[0].Edit == 1 && !loanSummary.CloseDate
              " [class.spinner]="loading" class="mt-3 btn font-size-12 button-btn">
              Edit
            </button>
          </div> -->
           <!-- <div class="text-right mb-2" style="margin-right: 3.125rem">
            <button type="button" (click)="editAssetInfo(Info.AssetId)" *ngIf="
                PageAcess && PageAcess[0].Edit == 1 && !loanSummary.CloseDate
              " class="mt-3 btn font-size-12 button-btn" [class.spinner]="loading">
              Edit
            </button>
          </div> -->
        </ng-container>

        <!-- Gold Section -->
        <ng-container *ngIf="Collateral == 'Gold'">
          <div class="info-card" *ngIf="dataviewAssetItemSource && dataviewAssetItemSource.data && dataviewAssetItemSource.data.length > 0">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-gem"></i>
                Gold Info
              </h2>
            </div>

            <div class="modern-table-wrapper">
              <mat-table [dataSource]="dataviewAssetItemSource" class="modern-table">
                <ng-container matColumnDef="Id">
                  <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
                  <mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="ItemName">
                  <mat-header-cell *matHeaderCellDef>Item Name</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.ItemName }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="ItemType">
                  <mat-header-cell *matHeaderCellDef>Item Type</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.ItemType }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Qty">
                  <mat-header-cell *matHeaderCellDef>Qty</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.Qty }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="PurityCT">
                  <mat-header-cell *matHeaderCellDef>Purity CT</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.PurityCT }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="GrossWt">
                  <mat-header-cell *matHeaderCellDef>Gross Wt</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.GrossWt }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="StoneWt">
                  <mat-header-cell *matHeaderCellDef>Stone Wt</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.StoneWt }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="OtherWt">
                  <mat-header-cell *matHeaderCellDef>Other Wt</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.OtherWt }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="NetWt">
                  <mat-header-cell *matHeaderCellDef>Net Wt</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.NetWt }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="PureWt">
                  <mat-header-cell *matHeaderCellDef>Pure Wt</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    {{ ((row.NetWt * (row.PurityCT * fixrate24ct)) / 100).toFixed(2) }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ValulationRate_PerCT">
                  <mat-header-cell *matHeaderCellDef>Rate</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.ValulationRate_PerCT }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="ValulationAmount">
                  <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
                  <mat-cell *matCellDef="let row">{{ row.ValulationAmount }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="Image">
                  <mat-header-cell *matHeaderCellDef>Images</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <div class="image-links">
                      <a [href]="applicationDocUrl + ApplicationNo.ApplicationNo + '/' + encodeURL(row.Image1)"
                        target="_blank" *ngIf="row.Image1" class="image-link">
                        <i class="fas fa-eye"></i>
                      </a>
                      <a href="{{ applicationDocUrl }}{{ ApplicationNo.ApplicationNo }}/{{ row.Image2 }}" 
                         target="_blank" *ngIf="row.Image2" class="image-link">
                        <i class="fas fa-eye"></i>
                      </a>
                    </div>
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedViewAssetItemColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedViewAssetItemColumns"></mat-row>
              </mat-table>
            </div>
          </div>

          <div class="info-card" *ngIf="Info">
            <div class="info-grid">
              <div class="info-item" *ngIf="Info.ValulationDoneBy">
                <label>Valuation Done By</label>
                <p>{{ Info.ValulationDoneBy }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValulationDate">
                <label>Valuation Date</label>
                <p>{{ Info.ValulationDate }}</p>
              </div>
              <div class="info-item" *ngIf="Info.TotalValulationAmount">
                <label>Total Valuation Amount</label>
                <p class="amount">{{ Info.TotalValulationAmount }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuerPhoneNo">
                <label>Valuer Phone No</label>
                <p>{{ Info.ValuerPhoneNo }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuerFirmName">
                <label>Valuer Firm Name</label>
                <p>{{ Info.ValuerFirmName }}</p>
              </div>
            </div>
          </div>
          
          <!-- <div class="text-right mb-2" style="margin-right: 3.125rem">
            <button type="button" (click)="editAssetInfo(Info.Id)" *ngIf="
                Info && Info.Id && PageAcess && PageAcess[0].Edit == 1 && !loanSummary.CloseDate
              " [class.spinner]="loading" class="mt-3 btn font-size-12 button-btn">
              Edit
            </button>
          </div> -->
        </ng-container>

        <!-- Consumer Durable Section -->
        <ng-container *ngIf="Collateral == 'Consumer_Durable'">
          <div class="info-card" *ngIf="Info">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-tv"></i>
                Consumer Durable Details
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.Category_Name">
                <label>Category</label>
                <p>{{ Info.Category_Name }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Manufacture_Name">
                <label>Manufacturer</label>
                <p>{{ Info.Manufacture_Name }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Product_Name">
                <label>Product Name</label>
                <p>{{ Info.Product_Name }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Model_Name">
                <label>Model</label>
                <p>{{ Info.Model_Name }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Varient">
                <label>Variant</label>
                <p>{{ Info.Varient }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Identification_No1">
                <label>Identification No. 1</label>
                <p>{{ Info.Identification_No1 }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Identification_No2">
                <label>Identification No. 2</label>
                <p>{{ Info.Identification_No2 }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Cost">
                <label>Cost</label>
                <p class="amount">{{ Info.Cost }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Color">
                <label>Color</label>
                <p>{{ Info.Color }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Invoice_No">
                <label>Invoice No.</label>
                <p>{{ Info.Invoice_No }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Invoice_Date">
                <label>Invoice Date</label>
                <p>{{ Info.Invoice_Date }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Dealer_Name">
                <label>Dealer Name</label>
                <p>{{ Info.Dealer_Name }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DealerContactPerson">
                <label>Dealer Contact Person</label>
                <p>{{ Info.DealerContactPerson }}</p>
              </div>
              <div class="info-item" *ngIf="Info.DealerContactNo">
                <label>Dealer Contact No.</label>
                <p>{{ Info.DealerContactNo }}</p>
              </div>
            </div>
          </div>

          <!-- Consumer Durable Images -->
          <div class="info-card" *ngIf="AssetsAttachment && AssetsAttachment.length > 0">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-images"></i>
                Product Images
              </h2>
            </div>

            <div class="attachments-list">
              <div class="attachment-item" *ngFor="let report of AssetsAttachment; let i = index">
                <span class="attachment-index">{{ i + 1 }}</span>
                <span class="attachment-title">{{ report.Title }}</span>
                <a href="{{ applicationDocUrl }}{{ ApplicationNo.ApplicationNo }}/{{ report.DocFileName }}" 
                   target="_blank" *ngIf="report.DocFileName" class="attachment-link">
                  <i class="fas fa-external-link-alt"></i>
                  {{ report.DocFileName }}
                </a>
              </div>
            </div>
          </div>

          <!-- <div class="text-right mb-2" style="margin-right: 3.125rem">
            <button type="button" (click)="editAssetInfo(Info.Id)" *ngIf="
                Info && Info.Id && PageAcess && PageAcess[0].Edit == 1 && !loanSummary.CloseDate
              " [class.spinner]="loading" class="mt-3 btn font-size-12 button-btn">
              Edit
            </button>
          </div> -->
        </ng-container>
      

        <!-- Property Section -->
        <ng-container *ngIf="Collateral == 'Property'">
          <div class="info-card" *ngIf="Info">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-building"></i>
                Property Details
              </h2>
            </div>

            <div class="info-grid">
              <div class="info-item" *ngIf="Info.CustomerId">
                <label>Property Owner</label>
                <p>{{ Info.CustomerId }}</p>
              </div>
              <div class="info-item info-item-full" *ngIf="Info.Address">
                <label>Address</label>
                <p>{{ Info.Address }}</p>
              </div>
              <div class="info-item" *ngIf="Info.State">
                <label>State</label>
                <p>{{ Info.State }}</p>
              </div>
              <div class="info-item" *ngIf="Info.District">
                <label>District</label>
                <p>{{ Info.District }}</p>
              </div>
              <div class="info-item" *ngIf="Info.tasil">
                <label>Tehsil</label>
                <p>{{ Info.tasil }}</p>
              </div>
              <div class="info-item" *ngIf="Info.PinCode">
                <label>Pincode</label>
                <p>{{ Info.PinCode }}</p>
              </div>
              <div class="info-item" *ngIf="Info.TypeofProperty">
                <label>Type of Property</label>
                <p>{{ Info.TypeofProperty }}</p>
              </div>
              <div class="info-item" *ngIf="Info.NatureofProperty">
                <label>Nature of Property</label>
                <p>{{ Info.NatureofProperty }}</p>
              </div>
              <div class="info-item" *ngIf="Info.OwnershipType">
                <label>Ownership Type</label>
                <p>{{ Info.OwnershipType }}</p>
              </div>
              <div class="info-item" *ngIf="Info.OwnershipDocument">
                <label>Ownership Document</label>
                <p>{{ Info.OwnershipDocument }}</p>
              </div>
              <div class="info-item" *ngIf="Info.UnitofMeasurement">
                <label>Unit of Measurement</label>
                <p>{{ Info.UnitofMeasurement }}</p>
              </div>
              <div class="info-item" *ngIf="Info.TotalArea">
                <label>Total Area</label>
                <p>{{ Info.TotalArea }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ConstructedArea">
                <label>Constructed Area</label>
                <p>{{ Info.ConstructedArea }}</p>
              </div>
              <div class="info-item" *ngIf="Info.TypeofMortgage">
                <label>Type of Mortgage</label>
                <p>{{ Info.TypeofMortgage }}</p>
              </div>
              <div class="info-item" *ngIf="Info.MortgageSingedBy">
                <label>Mortgage Signed By</label>
                <p>{{ Info.MortgageSingedBy }}</p>
              </div>
              <div class="info-item" *ngIf="Info.Cersai_No">
                <label>CERSAI No</label>
                <p>{{ Info.Cersai_No }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationAmount">
                <label>Valuation Amount</label>
                <p class="amount">{{ Info.ValuationAmount }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationDoneBy">
                <label>Valuation Done By</label>
                <p>{{ Info.ValuationDoneBy }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationRemark">
                <label>Valuation Remark</label>
                <p>{{ Info.ValuationRemark }}</p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationDoneByID != '' && Info.ValuationDoneByID == 0 && Info.ValuationDoneByOther">
                <label>Valuation Done By Name</label>
                <p>{{ Info.ValuationDoneByOther }}</p>
              </div>
              <div class="info-item" *ngIf="Info.SearchReportDoneBy">
                <label>Search Report Done By</label>
                <p>{{ Info.SearchReportDoneBy }}</p>
              </div>
              <div class="info-item" *ngIf="Info.SearchReportRemark">
                <label>Search Report Remark</label>
                <p>{{ Info.SearchReportRemark }}</p>
              </div>
              <div class="info-item" *ngIf="Info.SearchReportDoneByID != '' && Info.SearchReportDoneByID == 0 && Info.SearchReportDoneByOther">
                <label>Search Report Done By Name</label>
                <p>{{ Info.SearchReportDoneByOther }}</p>
              </div>
              <div class="info-item" *ngIf="Info.GeoLocation && Info.GeoLocation != '' && Info.GeoLocation != null && Info.GeoLocation != ','">
                <label>Location</label>
                <p>
                  <a target="_blank" 
                     [href]="'http://maps.google.com/maps?q=' + Info.GeoLocation"
                     class="location-link">
                    <i class="fas fa-map-marker-alt"></i>
                    View on Map
                  </a>
                </p>
              </div>
              <div class="info-item" *ngIf="Info.ValuationRemarkDoc">
                <label>Valuation Report</label>
                <p>
                  <a href="{{ applicationDocUrl }}{{ ApplicationNo.ApplicationNo }}/{{ Info.ValuationRemarkDoc }}" 
                     target="_blank" class="doc-link">
                    <i class="fas fa-file-pdf"></i>
                    {{ Info.ValuationRemarkDoc }}
                  </a>
                </p>
              </div>
              <div class="info-item" *ngIf="Info.SearchReportRemarkDoc">
                <label>Search Report</label>
                <p>
                  <a href="{{ applicationDocUrl }}{{ ApplicationNo.ApplicationNo }}/{{ Info.SearchReportRemarkDoc }}" 
                     target="_blank" class="doc-link">
                    <i class="fas fa-file-pdf"></i>
                    {{ Info.SearchReportRemarkDoc }}
                  </a>
                </p>
              </div>
            </div>
          </div>

          <!-- Property Images -->
          <div class="info-card" *ngIf="AssetsAttachment && AssetsAttachment.length > 0">
            <div class="card-header-section">
              <h2 class="section-title">
                <i class="fas fa-images"></i>
                Property Images
              </h2>
            </div>

            <div class="attachments-list">
              <div class="attachment-item" *ngFor="let report of AssetsAttachment; let i = index">
                <span class="attachment-index">{{ i + 1 }}</span>
                <span class="attachment-title">{{ report.Title }}</span>
                <a href="{{ applicationDocUrl }}{{ ApplicationNo.ApplicationNo }}/{{ report.DocFileName }}" 
                   target="_blank" *ngIf="report.DocFileName" class="attachment-link">
                  <i class="fas fa-external-link-alt"></i>
                  {{ report.DocFileName }}
                </a>
              </div>
            </div>
          </div>
          
          <!-- <div class="text-right mb-2" style="margin-right: 3.125rem">
            <button type="button" (click)="editAssetInfo(Info.Id)" *ngIf="
                Info&& Info.Id && PageAcess && PageAcess[0].Edit == 1 && !loanSummary.CloseDate
              " [class.spinner]="loading" class="mt-3 btn font-size-12 button-btn">
              Edit
            </button>
          </div> -->
        </ng-container>
      </div>
    </div>
  </div>
</div>